import { render, staticRenderFns } from "./cicleChartTwo.vue?vue&type=template&id=141c20e6&"
import script from "./cicleChartTwo.vue?vue&type=script&lang=js&"
export * from "./cicleChartTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports